// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledFlex = styled.div`
  align-items: ${({ alignItems = 'center' }) => alignItems};
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  display: flex;
  flex-direction: ${({ flexDirection = 'column' }) =>
    flexDirection === 'column' ? 'row' : 'column'};
  flex-wrap: ${({ flexWrap = 'nowrap' }) => flexWrap};
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};

  @media (max-width: 768px) {
    flex-direction: ${({ flexDirection = 'column' }) =>
    flexDirection === 'column' ? 'column' : 'row'};
  }
`
// #endregion

/**
 * Componente para renderizar un contenedor flex.
 *
 * @class
 * @example <Flex alignItems="flex-end" flexDirection="column" justifyContent="flex-start">...</Flex>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.alignItems="center"] - Atributo align items.
 * @param {string} [props.flexDirection="row"] - Atributo flex direction.
 * @param {string} [props.justifyContent="center"] - Atributo justify content.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Flex = ({ children, ...props }) => {
  return <StyledFlex {...props}>{children}</StyledFlex>
}

export default Flex
